import './../css/app.scss'
import './../../../../core/assets/js/core'
preloader(0);
loadjs.done('core');